var module = angular.module('octopusApp.environments');

module.controller('MachineEditController', function ($scope, $q, machineState, $location, $stateParams, busy, octopusLog, octopusRepository, octoDialog, endpoints) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var environmentId = $location.$$search["environment"];
    var endpoint = $location.$$search["type"];
    var hostname = $location.$$search["host"];
    var port = $location.$$search["port"];
    var uri = $location.$$search["uri"];
    var fingerprint = $location.$$search["fingerprint"];
    var thumbprint = $location.$$search["thumbprint"];
    var name = $location.$$search["name"];
    var proxyId = $location.$$search["proxyId"];
    $scope.machineId = $stateParams.machineId;
    $scope.communicationStyles = endpoints.communicationStyles;
    $scope.availableTenants = [];
    $scope.environments = [];
    $scope.teamSensitiveValues = { EnvironmentIds: [], TenantIds: [] };
    $scope.save = save;
    $scope.resetEndpoint = resetEndpoint;
    $scope.deleteMachine = deleteMachine;

    var unavailableTenants = [];
    var unavailableEnvironments = [];
    function configureFromExisting() {
        isLoading.promise(machineState.load().then(function (machine) {
            refreshMachinePolicy(machine.MachinePolicyId);
            $scope.machine = machine;
            $scope.teamSensitiveValues.EnvironmentIds = $scope.environments.filter(function(m){ return machine.EnvironmentIds.indexOf(m.Id) !== -1; }).map(function(e){return e.Id;});
            $scope.teamSensitiveValues.TenantIds = $scope.availableTenants.filter(function(t){return machine.TenantIds.indexOf(t.Id) !== -1;}).map(function(e){return e.Id;});

            unavailableTenants = machine.TenantIds.filter(function(tid) { return $scope.teamSensitiveValues.TenantIds.indexOf(tid) === -1; });
            unavailableEnvironments = machine.EnvironmentIds.filter(function(tid) { return $scope.teamSensitiveValues.EnvironmentIds.indexOf(tid) === -1; });
        }));
    }

    function configureFromNew(environments) {
        $scope.machine = {Endpoint: {CommunicationStyle: endpoint}, Status: 'Unknown'};

        if (environmentId) {
            $scope.teamSensitiveValues.EnvironmentIds = environments.filter(function(m){ return m.Id === environmentId; }).map(function(e){return e.Id;});
        }
        if (thumbprint) {
            $scope.machine.Endpoint.Thumbprint = thumbprint;
        }
        if (fingerprint) {
            $scope.machine.Endpoint.Fingerprint = fingerprint;
        }
        if (hostname || port) {
            $scope.machine.Name = hostname;
            $scope.machine.Endpoint.Host = hostname;
            $scope.machine.Endpoint.Port = port;
        }
        if (uri) {
            $scope.machine.Endpoint.Uri = uri;
        }
        if (name) {
            $scope.machine.Name = name;
        }
        if (proxyId) {
            $scope.machine.Endpoint.ProxyId = proxyId;
        }
        var defaultMachinePolicy = _.find($scope.machinePolicies, function (u) { return u.IsDefault; });
        $scope.machine.MachinePolicyId = defaultMachinePolicy.Id;
    }

    function refreshMachinePolicy(machinePolicyId) {
        var machinePolicy = _.find($scope.machinePolicies, function(machinePolicy){ return machinePolicy.Id === machinePolicyId;});
        if (machinePolicy == null) {
            octopusLog.log('Failed to find machine policy.');
        }
        $scope.machinePolicy = machinePolicy;
    }

    function init() {
        var tenantsP = octopusRepository.Tenants ? octopusRepository.Tenants.all().then(function (tenants) {
            $scope.availableTenants = tenants;
        }) : $q.resolve([]);

        var machineRolesP = octopusRepository.MachineRoles.all().then(function (machineRoles) {
            $scope.availableRoles = machineRoles;
        });

        var environmentsP = octopusRepository.Environments.all().then(function (environments) {
            $scope.environments = environments;
        });

        var policiesP = octopusRepository.MachinePolicies.all().then(function (machinePolicies) {
            $scope.machinePolicies = machinePolicies;
        });

        isLoading.promise($q.all([tenantsP, machineRolesP, environmentsP, policiesP]).then(function () {
            if ($scope.machineId) {
                configureFromExisting();
            } else {
                configureFromNew($scope.environments);
            }
        }));

        $scope.$watch('machine.MachinePolicyId', function (nv) {
            if (nv != null) {
                refreshMachinePolicy(nv);
            }
        });
    }

    function save() {
        $scope.machine.EnvironmentIds = [].concat(unavailableEnvironments).concat($scope.teamSensitiveValues.EnvironmentIds);
        $scope.machine.TenantIds = [].concat(unavailableTenants).concat($scope.teamSensitiveValues.TenantIds);
        isSaving.promise(octopusRepository.Machines.save($scope.machine).then(function (saved) {
            $location.path('/environments');
        }));
    }

    function resetEndpoint() {
        delete $scope.machine.Endpoint.Thumbprint;
        delete $scope.machine.Endpoint.Uri;
    }

    function deleteMachine() {
        var dlg = octoDialog.confirmDelete('machine', function () {
            return octopusRepository.Machines.del($scope.machine);
        });
        dlg.then(function (result) {
            if (result) {
                $location.path("/environments");
            }
        });
    }

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machines/edit_machine.js
// module id = 437
// module chunks = 1